import { render } from "./OptinFormTickets.vue?vue&type=template&id=50d2d3c8"
import script from "./OptinFormTickets.vue?vue&type=script&lang=js"
export * from "./OptinFormTickets.vue?vue&type=script&lang=js"

import "./OptinFormTickets.vue?vue&type=style&index=0&id=50d2d3c8&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__